import PageHeadline from "../../PageHeadline/PageHeadline";
import PageContentContainer from "../../Container/PageContentContainer";
import AttachmentMergeView from "../../AttachmentMerges/AttachmentMergeView.tsx";
import { useNavigate, useParams } from "react-router-dom";
import LegalbirdLoader from "../../ContentLoader/LegalbirdLoader";
import { useQuery } from "@tanstack/react-query";
import AttachmentMerge from "../../../types/AttachmentMerge.ts";
import { fetchResource, queryKeys } from "../../../services/ReactQuery/reactQueryService.ts";

export default function AttachmentMergePage() {
  const { attachmentMergeId } = useParams();
  const navigate = useNavigate();

  const attachmentMergeUri = "attachment_merges";
  const attachmentMergeIdAsNumber = Number(attachmentMergeId);

  const { data: attachmentMerge, isLoading } = useQuery<AttachmentMerge>({
    queryKey: queryKeys.item(attachmentMergeUri, attachmentMergeIdAsNumber),
    queryFn: () => fetchResource(attachmentMergeUri, attachmentMergeIdAsNumber),
    enabled: !!attachmentMergeId,
  });

  if (!attachmentMerge || isLoading) {
    return <LegalbirdLoader centered={true} />;
  }

  if (attachmentMerge.status !== "open") {
    navigate("/services/tools/anlagen");
  }

  return (
    <PageContentContainer>
      <PageHeadline main="Anhänge verarbeiten" />
      <AttachmentMergeView attachmentMerge={attachmentMerge} />
    </PageContentContainer>
  );
}
